<template>
  <div class="center" id="vue-app">
      <nav class="breadcrumb">
          <a href="/">HOME</a><span class="divider">/</span>{{ title }}
        </nav>

    <!-- Links to switch between Grid and Map view -->
    <div class="header">
        <div class="links-header">
            <div class="view-links">
            <button class="link uppercase" @click="switchGridView">
            <svg height="28" viewBox="0 0 30 28" width="30" xmlns="http://www.w3.org/2000/svg"><g fill="#276aa6" fill-rule="evenodd"><path d="m0 0h6v6h-6z"/><path d="m12 0h6v6h-6z"/><path d="m24 0h6v6h-6z"/><path d="m0 11h6v6h-6z"/><path d="m12 11h6v6h-6z"/><path d="m24 11h6v6h-6z"/><path d="m0 22h6v6h-6z"/><path d="m12 22h6v6h-6z"/><path d="m24 22h6v6h-6z"/></g></svg>
            Grid View
            </button>
            <button id="mapLink" class="link uppercase" @click="switchMapView">
            <svg height="32" viewBox="0 0 22 32" width="22" xmlns="http://www.w3.org/2000/svg"><path d="m11.001 1.072c5.291 0 9.596 4.305 9.596 9.597 0 1.683-.446 3.341-1.29 4.799l-8.307 14.394-8.308-14.395c-.843-1.456-1.289-3.115-1.289-4.798 0-5.292 4.305-9.597 9.597-9.597zm0 13.328c2.058 0 3.731-1.674 3.731-3.731s-1.674-3.731-3.731-3.731c-2.058 0-3.732 1.674-3.732 3.731s1.674 3.731 3.732 3.731zm0-14.394c-5.889 0-10.663 4.775-10.663 10.663 0 1.945.523 3.762 1.432 5.332l9.23 15.994 9.23-15.994c.909-1.57 1.432-3.387 1.432-5.332 0-5.888-4.774-10.663-10.662-10.663zm0 13.328c-1.472 0-2.666-1.193-2.666-2.665 0-1.471 1.194-2.665 2.666-2.665s2.665 1.194 2.665 2.665c0 1.472-1.193 2.665-2.665 2.665z" fill="#276aa6" transform=""/></svg>Map Results
            </button>
            <router-link to="/available-properties/login/?redirect=/available-properties" class="link uppercase" v-if="!loggedIn">
            <i class="fas fa-user-alt"></i>Login
            </router-link>
            <router-link to="/available-properties/applications/" class="link uppercase" v-if="loggedIn">
            <svg height="37" viewBox="0 0 38 37" width="38" xmlns="http://www.w3.org/2000/svg"><g fill="none" transform=""><g fill="#276aa6"><path d="m37.6594074.10189754c-.2111111-.12949948-.4742963-.13519176-.6917407-.01921146l-11.6343334 6.22807125-11.6336296-6.22807125c-.0091481-.00498075-.0197037-.00640382-.0288518-.01067303-.0337778-.01636532-.0682593-.02846143-.1034445-.03913446-.0197037-.00569229-.0387037-.01209611-.0584074-.01636532-.0387037-.00782689-.0781111-.01067304-.1182222-.01209611-.0175926-.00071153-.0351852-.00284614-.0534815-.0021346-.038.0021346-.0752963.00924996-.1125926.01778839-.0211111.00426921-.0422222.00711535-.0626296.01351917-.004926.00142307-.0098519.00142307-.0140741.00284615l-12.66666667 4.26921369c-.28781481.09676885-.48133333.36857545-.48133333.6752473v30.59603154c0 .2284029.10837037.4432867.29274074.5777669.12103704.0875189.2652963.1337687.41096296.1337687.0745926 0 .14988889-.0120961.22237037-.0369999l12.41755553-4.1852525 11.7215926 4.8804228c.0098519.0042692.0211111.0028462.030963.0064038.0774074.0277499.1562222.0469614.2371481.0469614.0633334 0 .125963-.010673.1871852-.0277499.0197037-.0056923.038-.0149422.0577037-.0220576.0281482-.010673.0577037-.0184999.0844445-.0327306l11.9629629-6.4038206c.2301111-.1230956.3743704-.3657293.3743704-.6289975v-29.17296023c0-.24974901-.1294815-.48099808-.3405926-.60978603zm-36.25199999 5.3920169 11.25925929-3.79461944v19.2057694c-.3025926.0554997-.600963.1181149-.8894815.1949607-.3757778.1010381-.5995556.4902481-.4996296.8702081.0837407.3187679.368037.5293825.6797777.5293825.0591111 0 .1203334-.0078269.1808519-.0234807.1688889-.0455383.3532592-.0683074.5284815-.1053073v8.4245817l-11.25925929 3.7939079zm12.66666669 16.67768336c.2258889-.0177884.4447407-.0469614.6762592-.0519421.3884445-.0085385.6966667-.3337102.688926-.7264779-.0084445-.3877869-.3215926-.6965934-.7037037-.6965934-.004926 0-.0105556 0-.0154815 0-.2181482.0049808-.4327778.0170769-.646.0320191v-18.83505928l10.5555555 5.65030433v15.08028585c-.5024444-.0220576-1.0133333-.0818266-1.5488518-.1864223-.3828148-.0761343-.7508519.1771723-.8247408.5628246-.0738889.3856524.175926.7592086.5573334.8339198.6234815.1223841 1.2286666.1821531 1.8169629.2056338v11.1860514l-10.5562592-4.3951555zm22.5185185 7.2839901-10.5555556 5.6503043v-11.1426478c.2617778-.1202495.4362963-.390633.4130741-.6973049-.0204074-.2661143-.1892963-.479575-.4130741-.5841707v-15.13792025l10.5555556-5.65030433z"/><path d="m7.5 6c-1.9299 0-3.5 1.55284615-3.5 3.46153846 0 1.67192304 1.2047 3.06969234 2.8 3.39161534v1.4545385c0 .3828462.3136.6923077.7.6923077s.7-.3094615.7-.6923077v-1.4545385c1.5953-.321923 2.8-1.7196923 2.8-3.39161534 0-1.90869231-1.5701-3.46153846-3.5-3.46153846zm0 5.5384615c-1.1578 0-2.1-.9318461-2.1-2.07692304 0-1.14507692.9422-2.07692308 2.1-2.07692308s2.1.93184616 2.1 2.07692308c0 1.14507694-.9422 2.07692304-2.1 2.07692304z"/><path d="m31.4134972 18.953434c.0781414.0321853.1582363.046566.2370289.046566.2604712 0 .5059653-.1650352.6068979-.4355287.3060537-.8210674.5515478-1.7482779.731273-2.7556092.0664202-.3711581-.1667016-.7286203-.5202913-.799154-.3555432-.0616314-.6935046.1759919-.7599248.5478348-.1640969.9231017-.3874509 1.7667673-.6635504 2.5083987-.1308868.3512991.0338612.7491641.3685667.8874924z"/><path d="m9.77567789 22.0995383c-.96537918.491857-1.83558013 1.1078153-2.58740816 1.8322809-.28473487.2741924-.24154475.6841815.09597804.9154907.15036561.1026597.33352371.1526901.51508218.1526901.22794786 0 .45349627-.0786191.61186005-.2306595.64465254-.6211562 1.38928222-1.1493989 2.2138936-1.5684844.3743144-.191025.4870886-.5919177.2527422-.8959983-.2343464-.3040807-.7286333-.3963445-1.10214791-.2053195z"/><path d="m5.6378247 26.0631019c-.31292844-.1582189-.68320631-.0089428-.82720326.336387-.63957087 1.5312835-.79790518 2.7674544-.80476218 2.8197354-.04675225.3762857.19137257.7223035.53235236.7738966.02867472.0048154.0579728.0068791.08602416.0068791.30607143 0 .57287098-.2490227.61712978-.5922889.00124673-.0110065.14399695-1.0985892.70128385-2.4310673.14399695-.3460177.00748036-.7539472-.30482471-.9135419z"/><path d="m28.7921492 23c.120936 0 .2442433-.0232312.3588558-.0723486 1.021237-.4387381 1.9215381-1.0613345 2.674819-1.8492045.2734892-.2860758.2189494-.7042376-.1217264-.933231-.3398854-.2276658-.837857-.1831947-1.1113462.1022174-.6133746.6418452-1.3405712 1.1456306-2.1618292 1.4980813-.3888921.1672647-.5430262.5668415-.3438376.893406.1406968.2289934.4181381.3610794.7050646.3610794z"/><path d="m20.5804366 21.7131412c-.3010145-.1237364-.4771181-.2093486-.4887219-.2153682-.0443672-.0220719-.0914647-.0401307-.1399273-.05217-.739226-.185939-1.4675307-.333085-2.1658023-.4374249-.372002-.0575207-.7207965.194634-.7781326.5598237-.0566535.3651896.1993111.7069697.5719957.7624838.6320621.0949761 1.2921096.2274075 1.9637609.3946189.0914647.0428061.2662032.1237364.5105641.2233944.0860042.0354488.1754212.0515011.2627904.0515011.2668858 0 .5208028-.1538345.6300144-.4106711.1453879-.3424489-.0184295-.7343924-.3665414-.8761877z"/><path d="m6.19548371 19.8046748c.12998917.1299946.30064161.1953252.47129406.1953252.17065244 0 .34130489-.0653306.47129406-.1953252l.86192817-.8619641.86192817.8619641c.12998917.1299946.30064162.1953252.47129406.1953252.17065245 0 .34130489-.0653306.47129406-.1953252.26064491-.2606558.26064491-.6819716 0-.9426274l-.86192817-.8619641.86192817-.8619641c.26064491-.2606558.26064491-.6819715 0-.9426273-.26064495-.2606559-.68194317-.2606559-.94258812 0l-.86192817.861964-.86192817-.861964c-.26064495-.2606559-.68194317-.2606559-.94258812 0-.26064495.2606558-.26064495.6819715 0 .9426273l.86192817.8619641-.86192817.8619641c-.26064495.2599892-.26064495.6819716 0 .9426274z"/></g><path d="m34.8974867 8.09971313c-.1366776-.13295084-.358271-.13295084-.494976 0l-4.1932136 4.07851117-1.6118027-1.5676976c-.1366776-.1329509-.3582711-.1329376-.494976 0-.1366912.1329375-.1366912.3484674 0 .4814182l1.8592907 1.8083868c.1366366.1329376.3583941.1328445.494976 0l4.4407016-4.31918704c.1366912-.13293755.1366776-.34848068 0-.48143153z" fill="#174f80"/></g></svg>
            Check Application Status
            </router-link>
            <div class="logout" v-if="loggedIn">
                <button class="btn logout uppercase" v-on:click="logout"><i class="fas fa-user-alt"></i>Logout</button>
            </div>
        </div>
    <!-- end view links -->
    
    <!-- Map Key -->
        <div class="map-key">
            <p>MAP KEY</p>
            <div class="items">
                <div class="item">Residential</div>
                <div class="item">Commercial</div>
                <div class="item">Industrial</div>
            </div>
        </div>
        <!-- end Map Key -->
    </div>

    

    <div class="header-filters">
        <!-- Desktop Filters -->
        <div class="filters">
            <div class="filter-field">
                <label for="address">Address</label>
                <input name="address" id="address" v-model="address">
            </div>
            <div class="filter-field">
                <label for="neighborhood">Neighborhood</label>
                <select name="neighborhood" id="neighborhood" v-model="neighborhood">
                    <option value=""> </option>
                    <option v-for="item in neighborhoodList" :value="item" v-bind:key="item">{{ item }}</option>
                </select>
            </div>
            <div class="filter-field">
                <label for="type">Property Type</label>
                <select name="type" id="type" v-model="propertyType">
                    <option value=""> </option>
                    <option v-for="item in propertyTypeList" :value="item" v-bind:key="item">{{ item }}<i class="fa fa-chevron-right"></i></option>
                </select>
            </div>
            <div class="filter-field">
                <label for="applicationtype">Application Type</label>
                <select class="filter" name="applicationtype" id="applicationtype" v-model="applicationType">
                    <option value=""> </option>
                    <option value="no_lty">Lot-to-Yard</option> 
                    <option value="no_g_and_g">Gardens and Greens</option> 
                    <option value="no_sfhd">Single Family Home Development</option> 
                    <option value="no_cd">Commercial Development</option> 
                </select>
            </div>
            <div class="filter-field">
                <label for="price_range">Price Range</label>
                <select class="filter" name="price_range" id="price_range" v-model="priceRange">
                    <option value=""> </option>
                    <option value="1000-5000">$1,000 - $5,000</option>
                    <option value="5000-15000">$5,000 - $15,000</option>
                    <option value="15000-25000">$15,000 - $25,000</option>
                    <option value="25000-50000">$25,000 - $50,000</option>
                    <option value="50000-100000">$50,000 - $100,000</option>
                    <option value="100000">>$100,000</option>
                </select>
            </div>
        </div>
        <!-- end Desktop Filters -->

        <!-- Mobile Filtering Dropdown -->
      <div class="dropdown mobile-filters">
          <a class="btn dropdown-toggle" role="button" id="dropdownMenuLink" aria-haspopup="true" aria-expanded="false" v-on:click="dropdownToggle">
               Search for Properties<i class="fa fa-chevron-down"></i></a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" id="mobileFilters" >
            
                <div class="filter-field">
                    <label for="addressMobile">Address</label>
                    <input class="filter" name="addressMobile" id="addressMobile" v-model="address">
                </div>
                <div class="filter-field">
                    <label for="neighborhoodMobile">Neighborhood</label>
                    <select class="filter" name="neighborhoodMobile" id="neighborhoodMobile" v-model="neighborhood" @click.native.capture.stop>
                        <option value=""> </option>
                        <option v-for="item in neighborhoodList" :value="item" v-bind:key="item">{{ item }}</option>
                    </select>
                </div>
                <div class="filter-field">
                    <label for="type">Property Type</label>
                    <select class="filter" name="type" id="type" v-model="propertyType">
                        <option value=""> </option>
                        <option v-for="item in propertyTypeList" :value="item" v-bind:key="item">{{ item }}</option>
                    </select>
                </div>
                <div class="filter-field">
                    <label for="applicationtype">Application Type</label>
                    <select class="filter" name="applicationtype" id="applicationtype" v-model="applicationType">
                        <option value=""> </option>
                        <option value="no_lty">Lot-to-Yard</option> 
                        <option value="no_g_and_g">Gardens and Greens</option> 
                        <option value="no_sfhd">Single Family Home Development</option> 
                        <option value="no_cd">Commercial Development</option> 
                    </select>
                </div>
                <div class="filter-field">
                    <label for="price_range">Price Range</label>
                    <select class="filter" name="price_range" id="price_range" v-model="priceRange">
                        <option value=""> </option>
                        <option value="1000-5000">$1,000 - $5,000</option>
                        <option value="5000-15000">$5,000 - $15,000</option>
                        <option value="15000-25000">$15,000 - $25,000</option>
                        <option value="25000-50000">$25,000 - $50,000</option>
                        <option value="50000-100000">$50,000 - $100,000</option>
                        <option value="100000">>$100,000</option>
                    </select>
                </div>
            </div>
        </div>
        <!-- end Mobile Filtering Dropdown -->
    </div>
    </div>

    

    

    <double-bounce v-if="loading"></double-bounce>
    
    <!-- Grid View layout -->
    <div v-if="gridView" id="gridView">
        <div class="property-grid">
            <div v-if="noResults">There are no results that match your search criteria.</div>
            <router-link class="property-item" v-for="property in paginatedData" :to="'/available-properties/' + property.ppn + '/'" v-bind:key="property.ppn">
                    <div v-if="property.main_pic_link" class="image" :style="{'background-image': 'url(' + property.main_pic_link + ')'}"></div>
                    <div v-else class="image" style="background-image:url('/assets/images/default house image@2x.png')"></div>
                    <div v-if="property.featured_property" class="featured">FEATURED</div>
                    <p :class="'address ' + property.hclrc_prop_type">{{ property.parcel_address }}</p>
                    <p class="price" v-if="property.suggested_listing_price"><strong>Price:</strong> ${{ formatPrice(property.suggested_listing_price) }}</p>
                    <p class="neighborhood"><strong>Neighborhood:</strong> {{ property.neighborhood }}</p>
                    <p :class="'type ' + property.hclrc_prop_type">{{ property.hclrc_prop_type }}</p>
            </router-link>
        </div>
        <div class="pag-nav">
            <span>Showing {{ pageNumber * perPage + 1 }} to {{ pageNumber * perPage + paginatedData.length }} of {{ filteredData.length }}  entries</span>
            <button class="btn btn-primary prev" v-on:click="prevPage" :disabled="pageNumber==0">Previous</button>
            <button class="btn btn-primary next" v-on:click="nextPage" :disabled="pageNumber >= pageCount-1">Next</button>
        </div>
    </div>
    <!-- end Grid View -->

    <!-- Map View Layout -->
        <mapbox v-if="loadMap" 
            v-bind:allPropertyData="allpropertyData" 
            v-bind:filteredData="filteredData" 
            v-bind:address="address" 
            v-bind:neighborhood="neighborhood"
            v-bind:parcelNum="parcelNum"
            v-bind:propertyType="propertyType"
        ></mapbox>
    <!-- end Map View -->

    <p class="disclaimer light">
            DISCLAIMER:  These are Landbank properties that are currently available. We may own other properties but they are not available at this time. All information on this list is subject to change.  Therefore, the HCLRC or the Port of Greater Cincinnati Development Authority do not guarantee the accuracy of this information and each user utilizes this information at his or her own risk. The HCLRC and the Port of Greater Cincinnati Development Authority are not responsible for, and expressly disclaim all liability for, damages of any kind arising out of use, reference to, or reliance on any information contained herein. By utilizing this site, the user agrees to these terms and agrees to hold the HCLRC and the Port of Greater Cincinnati Development Authority harmless from all claims arising out of use, reference to, or reliance on any information contained herein.
    </p>

  </div> <!-- end vue-app -->
  

</template>

<script>
import axios from 'axios';
import {DoubleBounce} from 'vue-loading-spinner';
import Mapbox from './Mapbox';


$(document).on('click', function(event) {
    console.log($(event.target).parents('.mobile-filters'));
    if ($(event.target).parents('.mobile-filters').length != 0) {
        if ($(event.target).closest('.dropdown').length != 0) return false;
        if ($(event.target).hasClass('.dropdown-toggle')) return false;
        if ($(event.target).closest('.dropdown-menu').length != 0) return false;
        $('.dropdown-toggle').parent().removeClass('show');
        $('.dropdown-toggle').next().removeClass('show');
        $('.dropdown-toggle').removeClass('open');  
    }
    

})

export default {
  name: 'PropertyIndex',
  components: {
    DoubleBounce,
    Mapbox
  },
  data() {
    return {
        canStoreLocally: typeof (Storage) !== 'undefined',
        loggedIn: this.$store.state.loggedIn,
        allpropertyData: [],
        loading: true,
        neighborhoodList: [],
        propertyTypeList: [],
        address: this.$route.query.address ? this.$route.query.address : '',
        neighborhood: this.$route.query.neighborhood ? this.$route.query.neighborhood : '',
        propertyType: this.$route.query.propertyType ? this.$route.query.propertyType : '',
        applicationType: this.$route.query.applicationType ? this.$route.query.applicationType : '', 
        priceRange: this.$route.query.priceRange ? this.$route.query.priceRange : '',
        perPage: 12,
        pageNumber: 0,
        gridView: true,
        mapView: false,
        title: 'Available Properties'

    }
  },
  beforeRouteEnter (to, from, next) {
      console.log(from);
      next();
  },
  watch: {
      // If the user filters the data, reset the page number to 0
      filteredData() {
          this.pageNumber = 0;
      },
      updatedQueryParameters() {
        this.$router.replace({path: '/available-properties/', query: this.updatedQueryParameters});
      }
  },
  created: function(){
    // Check the URL for an indicator as to which view needs to be shown
    if (this.$route.hash == '#map') {
        this.mapView = true;
        this.gridView = false;
    }

    // Check if this was a reroute from logging out and log the user out
    if (this.$route.query.logout) {
        this.logout();
    }

    // Check if property data is already stored in local storage
        try {
            this.$set(this, 'allpropertyData', this.workWithLocalStorage('properties'));
            this.$set(this, 'neighborhoodList', this.workWithLocalStorage('neighborhoods'));
            this.$set(this, 'propertyTypeList', this.workWithLocalStorage('types'));
            this.$set(this, 'loading', false);

        } catch(e) {

             // Get data from the API
                axios.get('/wp-json/HCLRC/v1/publish-hclrc-parcels/')
                .then((response) => {
                    console.log(response);
                    $('#vue-app').removeClass('center');
                    this.$set(this, 'loading', false);

                    var unorderedData = [];
                    unorderedData = response.data.data.data.data;

                    var n = [];
                    var t = [];

                    // Create Neighborhood and Property Type dropdowns
                    for (var item of unorderedData) {
                        if (!this.$parent.includes(n, item.neighborhood)) {
                            n.push(item.neighborhood);
                        }
                        if (!this.$parent.includes(t, item.hclrc_prop_type)) {
                            t.push(item.hclrc_prop_type);
                        }
                        if (item.featured_property == 'Yes') {
                            this.allpropertyData.unshift(item);
                        } else {
                            this.allpropertyData.push(item);
                        }
                    }

                    n.sort();
                    this.$set(this, 'neighborhoodList', n);
                    this.$set(this, 'propertyTypeList', t);

                    this.storeValueLocally('properties', this.allpropertyData);
                    this.storeValueLocally('neighborhoods', this.neighborhoodList);
                    this.storeValueLocally('types', this.propertyTypeList);


            })
            .catch(function (error) {
            // if an error occurs, print that error
            console.log(error);
            });
        }

        // Check for query parameters
        if (this.$route.query.address) { this.$set(this, 'address', this.$route.query.address) }

    
  },
  computed: {
    loadMap() {
        if (this.loading == false && this.mapView == true) {
            return true;
        } 
        return false;
    },
    noResults() {
        if (this.loading == false && this.paginatedData.length == 0) {
            return true;
        }
        return false
    },

    // Filter all property data based on filter input fields
    filteredData() {
      return this.allpropertyData
      .filter(item => {
        if (typeof item.parcel_address != 'undefined') {
          return (item.parcel_address.toLowerCase().indexOf(this.address.toLowerCase()) > -1)
        }
        
        })
        .filter(item => {
            if (typeof item.neighborhood != 'undefined') {
                return (item.neighborhood.toLowerCase().indexOf(this.neighborhood.toLowerCase()) > -1)
            }
        })
        .filter(item => {
            if (typeof item.hclrc_prop_type != 'undefined') {
                return (item.hclrc_prop_type.toLowerCase().indexOf(this.propertyType.toLowerCase()) > -1)
            }
        })
        .filter(item => {
            if (this.applicationType == 'no_lty') {
                return (typeof item.no_lty == 'undefined')
            } else if (this.applicationType == 'no_g_and_g') {
                return (typeof item.no_g_and_g == 'undefined')
            } else if (this.applicationType == 'no_sfhd') {
                return (typeof item.no_sfhd == 'undefined')
            }
            else if (this.applicationType == 'no_cd') {
                return (typeof item.no_cd == 'undefined')
            } else {
                return true;
            }
        })
        .filter(item => {
            if (typeof item.suggested_listing_price != 'undefined') {
                if (this.priceRange.includes('-')) {
                    let dash = this.priceRange.indexOf('-');
                    let min = parseFloat(this.priceRange.substring(0, dash));
                    let max = parseFloat(this.priceRange.substring(dash+1, this.priceRange.length ));
                    console.log(max);
                    return ((parseFloat(item.suggested_listing_price) > min) && (parseFloat(item.suggested_listing_price) < max))
                } else if (this.priceRange != '') {
                    return parseFloat(item.suggested_listing_price) > 100000;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        })
    },

    // Pagination page count 
    pageCount() {
        let l = this.filteredData.length;
        let s = this.perPage;
        return Math.ceil(l/s);
    },

    // Paginate filtered data
    paginatedData() {
        var start = this.pageNumber * this.perPage;
        var end = start + this.perPage;
        return this.filteredData.slice(start, end);
    },


    updatedQueryParameters() {
        let queryParameters = {};
        if (this.address != '') { queryParameters.address = this.address; }
        if (this.neighborhood != '') { queryParameters.neighborhood = this.neighborhood; }
        if (this.propertyType != '') { queryParameters.propertyType = this.propertyType; }
        if (this.applicationType != '') { queryParameters.applicationType = this.applicationType; }
        if (this.priceRange != '') { queryParameters.priceRange = this.priceRange; }

        return queryParameters;
    }

  } ,
  methods: {  
    
    // Pagination next and previous methods 
    nextPage: function() {
        this.pageNumber = this.pageNumber+1;
    },
    prevPage: function() {
        this.pageNumber = this.pageNumber-1;
    },
    formatPrice: function(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    dropdownToggle: function(event) {
        console.log(event.target);
        // Manually open and close dropodwn instead of using dropdown toggle to allow for inside clicks
        $(event.target).parent().toggleClass('show');
        $(event.target).next().toggleClass('show');
        $(event.target).toggleClass('open');
    },

    // Switch between Map and Grid views
    switchGridView: function() {
        this.gridView = true;
        this.mapView = false;
    },
    switchMapView: function() {
        this.gridView = false;
        this.mapView = true;
    },
     workWithLocalStorage: function (key) {
        if (!this.canStoreLocally) return func();
        key = 'HCLRC_' + key;
        var temporaryItem = this.$localStorage.get(key);
        if (temporaryItem) temporaryItem = JSON.parse(temporaryItem);
        if (temporaryItem && Date.now() < temporaryItem.expiresOn) {
            return temporaryItem.data;
        }
        else {
            throw "Expired";
        }
    },
    storeValueLocally: function (key, value) {
        if (!this.canStoreLocally) return;
        key = 'HCLRC_' + key;
        var expiry = new Date().setDate(new Date().getDate() + 1);
        expiry = new Date(expiry).setHours(0, 0, 0, 0);
        this.$localStorage.set(key, JSON.stringify({ data: value, expiresOn: expiry }));
    },

    logout() {
        this.$parent.logout();
    },
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.center {
    text-align: center;
}

.view-links {
    display: flex;
    margin-bottom: 2rem;
    text-align: left;

    .link {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 2rem;
        font-family: "din-2014";
        font-weight: 600;
        background-color: transparent;
        border: none;
        color: #276AA6 !important;


        svg, i {
            margin-right: .5rem;
        }
        i {
            font-size: 1.5rem;
        }
    }
    @media screen and (max-width: 992px) {
        margin-bottom: 1rem;
    }
}

.links-header {
    display: flex;

    .logout {
        font-weight: 700;
        a {
        color: #276AA6;

        }
    }

}

button {
    &.logout {
        color: #276AA6;
        font-size: 1rem;
        font-family: 'din-2014';
        font-weight: 700;
        padding-right: 0;

        i {
            margin-right: .5rem;
        }

    }
}

.header-filters {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: 1360px) {
        flex-direction: column;
        align-items: flex-start;
    }
}
.filters {
    display: flex;
    width: 90%;
    @media screen and (max-width: 1200px) {
        width: 100%;
    }
}
.filters, .dropdown-menu {

  label {
      font-family: 'din-2014';
      font-weight: 700;
  }
  
  
  .filter-field {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 3rem;
    flex-grow: 1;

    input, select {
        width: 100%;
    }

    select {
        background-color: #fff;
    }
     @media screen and (max-width: 1200px) {
        margin-right: 1.5rem;
    }
  }
}

.map-key {
    display: flex;
    margin-left: 2rem;
    p {
        font-family: 'din-2014';
        font-weight: 700;
        color: #276AA6;
    }
    .items {
        display: flex;
        flex-direction: row;
    }
    .item {
        margin-left: 1rem;
        font-family: "neue-haas-unica";
        font-weight: 600;
         &::before {
            display: inline-block;
            content: '';
            width: .75rem;
            height: .75rem;
            border-radius: 1.25rem;
            margin-right: .25rem;
        }
        &:first-of-type {
            &::before {
                background-color: #fdbb48;
            }
        }
        &:nth-of-type(2) {
            &::before {
                background-color: #e53d51;
            }
        }
        &:nth-of-type(3) {
            &::before {
                background-color: #533278;
            }
        }
    }
    @media screen and (max-width:450px) {
        margin-bottom: 2rem;
        flex-direction: column;
        justify-content: flex-start;
        width: 100%;
        text-align: left;
        p {
            margin-bottom: 0;
        }
        .items {
            justify-content: space-between

        }
        .item {
            margin-left: 0;
        }
    }
}

.mobile-filters {
    display: none;
    margin-bottom: 2rem;
    a {
        font-size: 1.125rem;
        width: 100%;
        border: 1px solid #C6C6C6;
        font-family: 'din-2014';
        &::after {
            display: none;
        }
    }
    
    i {
        font-size: .875rem;
        color: #dc3b43;
        margin-left: .5rem;
    }
    .dropdown-menu {
        flex-direction: column;
        padding: 1rem;
        width: 100%;
        margin: 0;
        border-radius: 0;
        border: 1px solid #C6C6C6;
        border-top: none;
        transform: translateY(50px) !important;
        


        .filter-field {
            margin-right: 0;
            margin-bottom: 1rem;
            
            input, select {
                width: 100%;
                border: 1px solid #C6C6C6;

            }
        }

    }

}



@media screen and (max-width: 992px) {

    .mobile-filters {
        display: block;
        width: 100%;
    }

    .filters {
        display: none;
    }
    .map-key {
        display: none;
    }
}
    


.pag-nav{
    display: flex;
    flex-direction: row;
    margin-top: 2rem;

    span {
        font-family: "neue-haas-unica";
        margin-right: 2rem;
    }
    button {
        padding: 1rem .75rem;
        margin-right: 1rem;
        width: 7.19rem;
        font-size: 1rem;
        text-transform: uppercase;
        font-family: 'din-2014';
        font-weight: 600;


        &.prev {
            display: flex;
            justify-content: space-around;
            &::before {
                font-family: 'Font Awesome 5 Free';
                content: "\f053";
            }
        }
        &.next {
            &::after {
                font-family: 'Font Awesome 5 Free';
                content: "\f054";
                margin-left: .25rem;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    #mapLink {
        display: none;
    }
}


#map {
    width: 100%;
    height: 500px;
    margin-top: 2rem;
}

.disclaimer {
    font-size: .875rem;
    margin-top: 2rem;

}

</style>



// WEBPACK FOOTER //
// src/components/PropertyIndex.vue